var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconVirus = function SvgIconVirus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    clipPath: "url(#icon-virus_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.959 24.5a8.542 8.542 0 1 0 17.083 0 8.542 8.542 0 0 0-17.083 0ZM24.5 15.958V9.125M22.792 9.125h3.416M30.54 18.46l4.832-4.832M34.164 12.42l2.416 2.416M33.042 24.5h6.833M39.875 22.792v3.416M30.54 30.54l4.832 4.832M36.58 34.164l-2.416 2.416M24.5 33.042v6.833M26.208 39.875h-3.416M18.46 30.54l-4.832 4.832M14.836 36.58l-2.414-2.416M15.958 24.5H9.125M9.125 26.208v-3.416M18.46 18.46l-4.832-4.832M12.42 14.836l2.416-2.414"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-virus_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4 4h41v41H4z"
  })))));
};
export default SvgIconVirus;